const getLocation = (role, userLeaves, leave, statusList) => {
  return userLeaves?.find((el) => el?._id === leave?._id);
};

export default getLocation;
